import React, { } from "react";
import {  Button, Modal, Form,  } from "antd";
import TextInput from "../../ReusableInputs/TextInput";
import TextAreaInput from "../../ReusableInputs/TextAreaInput";
import { AccessoryData } from "../../../@types/productInfo";



interface AcessoryModalProps {
  visible: boolean;
  onClose: () => void;
  name: string;
  sku: string;
  price:string;
  caption: string;
  description: string;
  meta_description: string;
  meta_title: string;
  accessorylink: string;
  height: string;
  width: string;
  length: string;
  weight: string;

  image: string;
  loading: boolean;
  isEditModal: boolean;
  isUpdating: boolean;
  isProcessing: boolean;
  isModalVisible: boolean;
  setName: (value: string) => void;
  setHeight: (value: string) => void;
  setWidth: (value: string) => void;
  setLength: (value: string) => void;
  setWeight: (value: string) => void;
  setPrice: (value: string) => void;
  setSku: (value: string) => void;
  setCaption: (value: string) => void;
  setDescription: (value: string) => void;
  setMetaDescription: (value: string) => void;
  setMetaTitle: (value: string) => void;
  setAccessoryLink: (value: string) => void;
  setImage: (value: string) => void;
  handleFormSubmit: () => void;

  handleFileChangeImage: (
    e: React.ChangeEvent<HTMLInputElement>
  ) => Promise<void>;
  handleModalCancel: () => void;
  handleSaveEdit: (accessoryData: AccessoryData) => void;
}

const AccessoryModal: React.FC<AcessoryModalProps> = ({
  visible,
  onClose,
  isEditModal,
  handleSaveEdit,
  name,
  caption,
  description,
  meta_description,
  meta_title,
  accessorylink,
  setCaption,
  setMetaDescription,
  setName,
  setAccessoryLink,
  setMetaTitle,
  setDescription,
  setImage,
  image,
  isProcessing,
  isModalVisible,
  loading,
  handleFormSubmit,
  handleFileChangeImage,
  handleModalCancel,
  isUpdating,
  sku,
  setSku,
  price,
  setPrice,
  setHeight,
  height,
  setWidth,
  width,
  setLength,
  length,
  setWeight,
  weight,
}) => {
  const [form] = Form.useForm();

  //

  return (
    <Modal
      title={isUpdating ? "Update Accessory" : "Add Accessory"}
      visible={isModalVisible}
      onCancel={handleModalCancel}
      keyboard={false}
      footer={null}
      width={700}
      height={500}
      bodyStyle={{ maxHeight: "550px", overflowY: "auto" }}>
      <div className="p-4">
      <Form
          form={form}
          layout="vertical"
          name="productForm"
          onFinish={handleFormSubmit}>
          <>
          {/* <DetailHeader title={"Accessory Information"} /> */}
            <section className="flex flex-col md:flex-row md:space-x-4 w-full">
              <div className="w-1/2 p-2">
                <TextInput
                  title="Accessory Name"
                  placeholder="Accessory Name"
                  inputValue={name}
                  setInputValue={setName}
                />
              </div>
              <div className="w-1/2 p-2">
                <TextInput
                  title="Caption"
                  placeholder="Enter Caption"
                  inputValue={caption}
                  setInputValue={setCaption}
                />
              </div>
            </section>

            <section className="flex flex-col md:flex-row md:space-x-4 w-full">
              <div className="w-1/2 p-2">
                <TextInput
                  title="Accessory Price"
                  placeholder="Accessory Price"
                  inputValue={price}
                  setInputValue={setPrice}
                />
              </div>

              <div className="w-1/2 p-2">
                <TextInput
                  title="Accessory Sku Code"
                  placeholder="Enter Accessory Sku Code"
                  inputValue={sku}
                  setInputValue={setSku}
                />
              </div>
            </section>

            <TextAreaInput
              title="Description"
              placeholder="Enter Description"
              inputValue={description}
              setInputValue={setDescription}
            />
            
            <section className="flex flex-col md:flex-row md:space-x-4 w-full">
              <div className="w-1/2 p-2">
                <div className="w-full p-2">
                  <label
                    htmlFor="image-upload"
                    className="block text-gray-700 mb-3">
                    Image
                  </label>
                  <input
                    id="image-upload"
                    type="file"
                    accept="image/*"
                    onChange={handleFileChangeImage}
                  />
                  {image && (
                    <div className="p-4 w-full">
                      <img
                        src={image}
                        alt="Product Imag"
                        style={{ width: "auto", maxHeight: "100px" }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </section>
            <section className="flex flex-col md:flex-row md:space-x-4 w-full">
            <div className="w-1/2 p-2">
              <TextInput
                title="Width"
                placeholder="Enter product width"
                inputValue={width}
                setInputValue={setWidth}
              />
            </div>
            <div className="w-1/2 p-2">
              <TextInput
                title="Weight"
                placeholder="Please enter the Product weight!"
                inputValue={weight}
                setInputValue={setWeight}
              />
            </div>
          </section>

          <section className="flex flex-col md:flex-row md:space-x-4 w-full">
            <div className="w-1/2 p-2">
              <TextInput
                title="Height"
                placeholder="Enter product height"
                inputValue={height}
                setInputValue={setHeight}
              />
            </div>
            <div className="w-1/2 p-2">
              <TextInput
                title="Dept"
                placeholder="Please enter the Product dept!"
                inputValue={length}
                setInputValue={setLength}
              />
            </div>
          </section>
          </>

          <>
          {/* <DetailHeader title={"Accessory SEO"} /> */}
            <section className="flex flex-col md:flex-row md:space-x-4 w-full">
              <div className="w-1/2 p-2">
                <TextInput
                  title="Meta Title"
                  placeholder="Enter Meta Title"
                  inputValue={meta_title}
                  setInputValue={setMetaTitle}
                />
              </div>
              <div className="w-1/2 p-2">
                <TextInput
                  title="Accessory URL"
                  placeholder="Please enter the accessory URL!"
                  inputValue={accessorylink}
                  setInputValue={setAccessoryLink}
                />
              </div>
            </section>

            <section
              className=" md:flex-row md:space-x-4 w-full  p-2
            ">
              <TextAreaInput
                title="Meta Description"
                placeholder="Enter Meta Description"
                inputValue={meta_description}
                setInputValue={setMetaDescription}
              />
            </section>
          </>
        </Form>
    
      {isUpdating ? (
        <Button
          htmlType="submit"
          className="bg-teal-800 w-full mt-[7px] text-white font-semibold py-2 px-4 border border-gray-400 rounded shadow 
           hover:bg-white hover:text-teal-800"

          onClick={() =>
            handleSaveEdit({
              name,
              description,
              meta_description,
              meta_title,
              caption,
              image,
              accessorylink,
            })
          }
          loading={loading}>
          {loading ? "Updating..." : "Update Accessory"}
        </Button>
      ) : (
        <Button className="bg-teal-800 w-full mt-[7px]
        text-white font-semibold py-2 px-4 border
           border-gray-400 rounded shadow" htmlType="submit" onClick={handleFormSubmit} loading={loading}>
          {loading ? "Adding..." : "Add Accessory"}
        </Button>
      )}
      </div>
      
    </Modal>
  );
};

export default AccessoryModal;
